export default __webpack_public_path__ + "static/media/delete_white.3e9cc576.svg";